import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Text
} from '@axilon-apps/libs-ui-shadcn'
import { CopyToClipboard } from '@axilon-apps/libs-ui-components'
import type { Model } from '@axilon-apps/domains-identity/types'

interface Props {
  isOpen: boolean
  close: () => void
  user: Model.User
}

const userContext = ({ name, username }: Model.User) =>
  name.trim() ? `${name} · ${username}` : username

const ViewUserUuidModal = ({ isOpen, close, user }: Props) => (
  <Dialog open={isOpen} onOpenChange={(next) => !next && close()}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>View UUID</DialogTitle>
        <DialogDescription>{userContext(user)}</DialogDescription>
      </DialogHeader>
      <div className="flex items-center gap-2">
        <Text variant="body-sm" className="min-w-0 flex-1 font-mono break-all select-all">
          {user.id}
        </Text>
        <CopyToClipboard textToCopy={user.id} />
      </div>
    </DialogContent>
  </Dialog>
)

export default ViewUserUuidModal
